export const DELIVERY_BACK = 'DELIVERY_BACK';
export const DELIVERY_REQUEST = 'DELIVERY_REQUEST';
export const DELIVERY_NEW_ADDRESS = 'DELIVERY_NEW_ADDRESS';
